var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_setup.onClickOutside),expression:"onClickOutside"}],staticClass:"p-chip-btn",class:{
    'p-chip-btn--primary': _setup.active,
    'p-chip-btn--disabled': _setup.disabled,
  },on:{"click":_setup.click}},[_c('p-icon',{attrs:{"icon":_setup.getIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }